import React, { useEffect, useState } from "react";
import "./Shoulde.css";
import Logo from "./Logo";
import Header from "./Header";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import DropDown from "../Components/DropDown";
import DropdownDate from "react-dropdown-date";
import ConsultationFooter from "./ConsultationFooter";
import { Modal } from "react-bootstrap";
import { Button } from "antd";
const PatientInfo = ({
  firstName,
  lastName,
  city,
  state,
  ageInYear,
  setStep,
  setFirstName,
  setLastName,
  setEmail,
  setPhoneNumber,
  setAgeInYear,
  setState,
  setCity,
  setGender,
  parentName,
  setParentName,
  date,
  selectDate,
  isConsentAccepted,
  setIsConsentAccepted,
}) => {
  const [errors, setErrors] = useState({});
  const { user } = useSelector((state) => state.auth);
  const [showConsentModal, setShowConsentModal] = useState(false);

  useEffect(() => {
    if (user) {
      setFirstName(user?.patient?.firstName);
      setLastName(user?.patient?.lastName);
      setEmail(user?.patient?.email);
      setPhoneNumber(user?.patient?.phoneNumber);
      // setState(user?.patient?.state);
    }
  }, [user]);

  function calculateAge(birthday) {
    //milliseconds in a year 1000*24*60*60*365.24 = 31556736000;
    if (!birthday) {
      return "";
    }

    let today = new Date(),
      //birthay has 'Dec 25 1998'
      dob = new Date(birthday),
      //difference in milliseconds
      diff = today.getTime() - dob.getTime(),
      //convert milliseconds into years
      years = Math.floor(diff / 31556736000);

    setAgeInYear(years);
    return years;
  }
  const nextStep = () => {
    const valid = validate();
    if (valid > 0) return;

    setIsConsentAccepted(true);
    setShowConsentModal(false);
    setStep(1);
  };

  const showConsentModalHandler = () => {
    const valid = validate();
    if (valid > 0) return;

    setShowConsentModal(true);
  };

  const validate = () => {
    let errors = {};

    if (firstName.trim() === "") errors.firstName = "First Name is required";
    if (lastName.trim() === "") errors.lastName = "Last Name is required";
    if (city.trim() === "") errors.city = "Country is required";
    if (state.trim() === "") errors.state = "State is required";
    if (!ageInYear) errors.ageInYear = "Age is required";
    if (ageInYear < 18 && !parentName)
      errors.parentName = "Parent Name is Required";

    setErrors(errors);
    return Object.keys(errors).length;
  };

  return (
    <div className="patientinfo">
      <Logo />
      <div className="card wizard-card">
        <div className="centre_content">
          <Header active={0} />
        </div>
        <div className="scroll_div">
          <h4 className="centre_head">
            Let's start with the basic information
          </h4>
          <p
            className="redpara"
            style={{
              color: "#c0392b",
              textAlign: "center",
              fontWeight: "700",
              marginBottom: "15px",
              width: "95%",
            }}
          >
            SecondLook Ortho is HIPAA Compliant and utilizes end-to-end
            encryption to ensure that only you and the person you're
            communicating with can access your photos, video, and documents. We
            don't share or sell personal information.
          </p>
          <div
            className="form row "
            style={{
              display: "flex",
              flex: "wrap",
              paddingLeft: "35px",
              paddingRight: "35px",
              paddingBottom: "10px",
            }}
          >
            <div className="col-sm-4">
              <label
                htmlFor="validationDefault02"
                style={{ fontSize: "12px", fontFamily: "Poppins" }}
              >
                First Name*
              </label>
              <input
                type="text"
                className="form-control"
                id="validationDefault02"
                placeholder="FirstName"
                style={{ fontSize: "11px", fontFamily: "Poppins" }}
                required
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
                autoComplete="off"
              />
              {errors?.firstName && (
                <p
                  style={{
                    color: "red",
                    fontSize: "11px",
                    margin: "2px 0px 0px 2px",
                  }}
                >
                  {errors?.firstName}
                </p>
              )}
            </div>
            <div className="col-sm-4">
              <label
                htmlFor="validationDefault02"
                style={{ fontSize: "12px", fontFamily: "Poppins" }}
              >
                Last Name*
              </label>
              <input
                type="text"
                className="form-control"
                id="validationDefault02"
                placeholder="LastName"
                style={{ fontSize: "11px", fontFamily: "Poppins" }}
                required
                onBlur={validate}
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
                autoComplete="off"
              />
              {errors?.lastName && (
                <p
                  style={{
                    color: "red",
                    fontSize: "11px",
                    margin: "2px 0px 0px 2px",
                  }}
                >
                  {errors?.lastName}
                </p>
              )}
            </div>
            <div className="col-sm-4">
              <label
                htmlFor="validationDefault02"
                style={{ fontSize: "12px", fontFamily: "Poppins" }}
              >
                Email*
              </label>
              <input
                type="text"
                className="form-control"
                placeholder="Email"
                onBlur={validate}
                id="validationDefault02"
                style={{ fontSize: "11px", fontFamily: "Poppins" }}
                value={user?.patient?.email}
                disabled
                autoComplete="off"
              />
            </div>
          </div>
          <div
            className="form row "
            style={{
              display: "flex",
              flex: "wrap",
              paddingLeft: "35px",
              paddingRight: "35px",
              paddingBottom: "10px",
            }}
          >
            <div className="col-sm-4">
              <label
                htmlFor="validationDefault02"
                style={{ fontSize: "12px", fontFamily: "Poppins" }}
              >
                Phone*
              </label>
              <input
                type="text"
                className="form-control"
                // style={{ backgroundColor: "#eee" }}
                id="validationDefault02"
                onBlur={validate}
                placeholder="Phone Number"
                style={{ fontSize: "11px", fontFamily: "Poppins" }}
                required
                value={user?.patient?.phoneNumber}
                disabled
                autoComplete="off"
              />
            </div>

            <div
              className="col-sm-4"
              style={{
                paddingTop: "18px",
                paddingRight: "9px",
                paddingLeft: "9px",
                display: "flex",
              }}
            >
              <DropdownDate
                className="dateofbirth"
                onDateChange={(date) => {
                  selectDate(date);
                }}
                defaultValues={{
                  year: "Year",
                  month: "Month",
                  day: "Day",
                }}
              />
            </div>

            <div className="col-sm-4" style={{ paddingRight: "0" }}>
              <label
                htmlFor="validationDefault02"
                style={{ fontSize: "12px", fontFamily: "Poppins" }}
              >
                Age in Years*
              </label>
              <input
                type="text"
                className="form-control"
                // style={{ paddingRight: "0" }}
                id="validationDefault02"
                placeholder="age"
                disabled
                onBlur={validate}
                style={{
                  fontSize: "11px",
                  fontFamily: "Poppins",
                  width: "96%",
                }}
                value={calculateAge(date)}
                autoComplete="off"
              />
              {!ageInYear && errors?.ageInYear && (
                <p
                  style={{
                    color: "red",
                    fontSize: "11px",
                    margin: "2px 0px 0px 2px",
                  }}
                >
                  {errors?.ageInYear}
                </p>
              )}
            </div>
            {ageInYear < 18 && ageInYear ? (
              <div className="col-sm-4">
                <label
                  htmlFor="validationDefault02"
                  style={{
                    fontSize: "12px",
                    fontFamily: "Poppins",
                    paddingTop: "10px",
                    paddingBottom: "10px",
                  }}
                >
                  Parent/Guardian Name *
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="validationDefault02"
                  placeholder=" Enter Parent/Guardian Name *"
                  style={{ fontSize: "11px", fontFamily: "Poppins" }}
                  required
                  onBlur={validate}
                  value={parentName}
                  onChange={(e) => setParentName(e.target.value)}
                  autoComplete="off"
                />
                {errors?.parentName && (
                  <p
                    style={{
                      color: "red",
                      fontSize: "11px",
                      margin: "2px 0px 0px 2px",
                    }}
                  >
                    {errors?.parentName}
                  </p>
                )}
              </div>
            ) : null}
          </div>
          <div
            className="form row "
            style={{
              display: "flex",
              flex: "wrap",
              paddingBottom: "15px",
              paddingLeft: "35px",
              paddingRight: "35px",
            }}
          >
            {/* <div className="col-sm-4">
              <label
                htmlFor="validationDefault02"
                style={{ fontSize: "12px", fontFamily: "Poppins", }}
              >
                Country*
              </label>
              <DropDown
                endKey="city"
                value={city}
                onChangeSet={(city) => {
                  setCity(city);
                  setErrors({ ...errors, city: null });
                  validate();
                }}
              />
              {city !== "Select an Option" ||
                (errors?.city && (
                  <p
                    style={{
                      color: "red",
                      fontSize: "11px",
                      margin: "2px 0px 0px 2px",
                    }}
                  >
                    {errors?.city}
                  </p>
                ))}
            </div> */}
            <div className="col-sm-4">
              <label
                htmlFor="validationDefault04"
                style={{ fontSize: "12px", fontFamily: "Poppins" }}
              >
                Country
              </label>
              <input
                type="text"
                className="form-control"
                id="validationDefault04"
                placeholder="Country"
                style={{ fontSize: "11px", fontFamily: "Poppins" }}
                // required
                value={city}
                onBlur={validate}
                onChange={(e) => setCity(e.target.value)}
                autoComplete="off"
              />
              {errors?.city && (
                <p
                  style={{
                    color: "red",
                    fontSize: "11px",
                    margin: "2px 0px 0px 2px",
                  }}
                >
                  {errors?.city}
                </p>
              )}
            </div>

            {/* <div className="col-sm-4">
              <label
                htmlFor="validationDefault03"
                style={{ fontSize: "12px", fontFamily: "Poppins", }}
              >
                State
              </label>
              <input
                endKey="state"
                type="text"
                className="form-control"
                id="validationDefault03"
                placeholder="State"
                style={{ fontSize: "11px", fontFamily: "Poppins", }}
                // required
                value={state}
                // onChangeSet={(state) => {
                //   setState(state);
                //   setErrors({ ...errors, state: null });
                //   validate();
                // }}
                onChange={(e) => setState(e.target.value)}
              />
              {state !== "Select an Option" ||
                (errors?.state && (
                  <p
                    style={{
                      color: "red",
                      fontSize: "11px",
                      margin: "2px 0px 0px 2px",
                    }}
                  >
                    {errors?.state}
                  </p>
                ))}
            </div> */}

            <div className="col-sm-4">
              <label
                htmlFor="validationDefault04"
                style={{ fontSize: "12px", fontFamily: "Poppins" }}
              >
                State
              </label>
              <input
                type="text"
                className="form-control"
                id="validationDefault04"
                placeholder="State"
                style={{ fontSize: "11px", fontFamily: "Poppins" }}
                // required
                value={state}
                onBlur={validate}
                onChange={(e) => setState(e.target.value)}
                autoComplete="off"
              />
              {errors?.state && (
                <p
                  style={{
                    color: "red",
                    fontSize: "11px",
                    margin: "2px 0px 0px 2px",
                  }}
                >
                  {errors?.state}
                </p>
              )}
            </div>
          </div>

          <div
            className="genderdiv"
            style={{
              display: "flex",
              marginTop: "20px",
              paddingLeft: "35px",
              marginBottom: "50px",
            }}
          >
            <div className="btn-group btn-group-toggle" data-toggle="buttons">
              <label
                className="btn btn-secondary active"
                style={{
                  backgroundColor: "#fff",
                  color: "#000",
                  border: "none",
                  fontSize: "12px",
                  fontFamily: "Poppins",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <input
                  type="radio"
                  style={{
                    backgroundColor: "#fff",
                    marginRight: "7px",
                  }}
                  name="options"
                  id="option1"
                  defaultChecked
                  onClick={() => {
                    setGender("male");
                  }}
                  autoComplete="off"
                />
                Male
              </label>
              <label
                className="btn btn-secondary"
                style={{
                  backgroundColor: "#fff",
                  color: "#000",
                  border: "none",
                  fontSize: "12px",
                  fontFamily: "Poppins",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <input
                  type="radio"
                  name="options"
                  id="option2"
                  style={{ marginRight: "7px" }}
                  onClick={() => {
                    setGender("female");
                  }}
                  autoComplete="off"
                />
                Female
              </label>
              <label
                className="btn btn-secondary"
                style={{
                  backgroundColor: "#fff",
                  color: "#000",
                  border: "none",
                  fontSize: "12px",
                  fontFamily: "Poppins",
                }}
              >
                <input
                  type="radio"
                  name="options"
                  id="option3"
                  style={{ marginRight: "7px" }}
                  onClick={() => {
                    setGender("other");
                  }}
                  autoComplete="off"
                />
                Other
              </label>
            </div>
          </div>
          <div className="wizard-footer height-wizard">
            <div className="pull_left" style={{ paddingLeft: "10px" }}>
              <Link to="/">
                <button className="llll">CANCEL</button>
              </Link>
            </div>
            <div className="pull_right" style={{ paddingRight: "10px" }}>
              <button className="KKK" onClick={showConsentModalHandler}>
                NEXT
              </button>
            </div>
          </div>
        </div>
      </div>
      <ConsultationFooter />
      <Modal
        backdrop="static"
        keyboard={false}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={showConsentModal}
      >
        <div className="consent-modal-content-container">
          <h2>Consent for Telehealth Consultation</h2>
          <div className="consent-modal-content">
            <ol>
              <h4>CONSENT FOR TELEHEALTH CONSULTATION</h4>
              <li>
                I understand that my health care provider wishes me to engage in
                a telehealth consultation.
              </li>
              <li>
                My health care provider explained to me how the video
                conferencing technology that will be used to affect such a
                consultation will not be the same as a direct client/health care
                provider visit due to the fact that I will not be in the same
                room as my provider.
              </li>
              <li>
                I understand that a telehealth consultation has potential
                benefits including easier access to care and the convenience of
                meeting from a location of my choosing.
              </li>
              <li>
                I understand there are potential risks to this technology,
                including interruptions, unauthorized access, and technical
                difficulties. I understand that my health care provider or I can
                discontinue the telehealth consult/visit if it is felt that the
                videoconferencing connections are not adequate for the
                situation.
              </li>
              <li>
                I have had a direct conversation with my provider, during which
                I had the opportunity to ask questions in regard to this
                procedure. My questions have been answered and the risks,
                benefits and any practical alternatives have been discussed with
                me in a language in which I understand.
              </li>
            </ol>

            <ol>
              <h4>CONSENT TO USE THE TELEHEALTH BY CAREPATRON SERVICE</h4>
              <p>
                Telehealth by Carepatron is the technology service we will use
                to conduct telehealth videoconferencing appointments. It is
                simple to use and there are no passwords required to log in. By
                signing this document, I acknowledge:
              </p>
              <li>
                Telehealth by Carepatron is NOT an Emergency Service and in the
                event of an emergency, I will use a phone to call 911.
              </li>
              <li>
                Though my provider and I may be in direct, virtual contact
                through the Telehealth Service, neither Carepatron nor the
                Telehealth Service provides any medical or healthcare services
                or advice including, but not limited to, emergency or urgent
                medical services.
              </li>
              <li>
                The Telehealth by Carepatron Service facilitates
                videoconferencing and is not responsible for the delivery of any
                healthcare, medical advice or care.
              </li>
              <li>
                I do not assume that my provider has access to any or all of the
                technical information in the Telehealth by Carepatron Service –
                or that such information is current, accurate or up-to-date. I
                will not rely on my health care provider to have any of this
                information in the Telehealth by Carepatron Service.
              </li>
              <li>
                To maintain confidentiality, I will not share my telehealth
                appointment link with anyone unauthorized to attend the
                appointment.
              </li>
            </ol>

            <ul>
              <h4>By signing, I certify:</h4>
              <li>
                That I have read or had this form read and/or had this form
                explained to me.
              </li>
              <li>
                That I fully understand its contents including the risks and
                benefits of the procedure(s).
              </li>
              <li>
                That I have been given ample opportunity to ask questions and
                that any questions have been answered to my satisfaction.
              </li>
            </ul>

            <div className="consent-footer-buttons">
              <Button onClick={() => setShowConsentModal(false)}>Cancel</Button>
              <Button className="next-button" type="primary" onClick={nextStep}>
                Accept
              </Button>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default PatientInfo;
